var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#006BFF",
    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 4.8a7.2 7.2 0 1 1 0 14.4 7.2 7.2 0 0 1 0-14.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#006BFF",
    d: "M12 7.2a4.8 4.8 0 0 0-4.8 4.8c0 2.651 2.149 4.8 4.8 4.8 1.83 0 3.424-1.026 4.224-2.529l-2.093-1.047a2.4 2.4 0 0 1-2.131 1.176 2.4 2.4 0 0 1-2.4-2.4 2.4 2.4 0 0 1 2.4-2.4c.915 0 1.722.513 2.131 1.272l2.093-1.144A4.78 4.78 0 0 0 12 7.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendly);
export default __webpack_public_path__ + "static/media/calendly.942481f8db89af953cc1c6b6a8d26232.svg";
export { ForwardRef as ReactComponent };